import { Activity, ActivityType, PresentationMode } from '@/api/models/activity'
import { FrontActivityPart } from '@/store/slices/aggregateSlice/types/FrontActivityPart.type'
import { FrontActivityWithAggregate } from '@/store/slices/aggregateSlice/types/FrontActivityWithAggregate.type'

export const isLongRead = (activityWithAggregate: FrontActivityWithAggregate | null | undefined) =>
  !!activityWithAggregate &&
  (activityWithAggregate.presentationMode === PresentationMode.LongRead ||
    activityWithAggregate.presentationMode === PresentationMode.LongReadWithoutActivityNames) &&
  activityWithAggregate.type === ActivityType.composite &&
  !!activityWithAggregate.children?.length &&
  activityWithAggregate.children.every(
    (activityPart: FrontActivityPart<Activity>) => activityPart.childActivity.type !== ActivityType.composite,
  )
